import React, { createContext, useState, useEffect, useContext } from 'react';

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  // Load favorites from localStorage on initial render
  const [favorites, setFavorites] = useState(() => {
    const savedFavorites = localStorage.getItem('stoicFavorites');
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });

  // Save favorites to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('stoicFavorites', JSON.stringify(favorites));
  }, [favorites]);

  // Toggle a quote as favorite
  const toggleFavorite = (quote) => {
    setFavorites(prevFavorites => {
      // Use either _id or id for compatibility with both API and local data
      const quoteId = quote._id || quote.id;
      const isAlreadyFavorite = prevFavorites.some(fav => (fav._id || fav.id) === quoteId);

      if (isAlreadyFavorite) {
        return prevFavorites.filter(fav => (fav._id || fav.id) !== quoteId);
      } else {
        return [...prevFavorites, quote];
      }
    });
  };

  // Check if a quote is favorited
  const isFavorite = (quoteId) => {
    return favorites.some(fav => (fav._id || fav.id) === quoteId);
  };

  return (
    <FavoritesContext.Provider value={{ favorites, toggleFavorite, isFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
};

// Custom hook to use the favorites context
export const useFavorites = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error('useFavorites must be used within a FavoritesProvider');
  }
  return context;
};
